import Vue from 'vue'
import SvgIcon from './index.vue' // svg组件
import generateIconsView from './svg-icons/generateIconsView.js' 
Vue.component('svg-icon', SvgIcon)

const requireAll = requireContext => requireContext.keys().map(requireContext)
let req = null
let iconMap = []
try {
  // 一个webpack的api,通过执行require.context函数获取一个特定的上下文,主要用来实现自动化导入模块,在前端工程中,如果遇到从一个文件夹引入很多模块的情况,可以使用这个api,它会遍历文件夹中的指定文件,然后自动导入,使得不需要每次显式的调用import导入模块
  console.log('开始查找项目--自己svg文件夹：如果这里报找不到 Cant resolve ../../../svg没有关系')
  req = require.context('../../../svg', true, /\.svg$/) // 项目自己的icon
} catch (error) {
  console.log('项目没有建自己svg文件夹')
}
if(req){
  iconMap = requireAll(req)
}
const reqCommon = require.context('../../svg', true, /\.svg$/) // 全局公共的icon
const iconMapCommon = requireAll(reqCommon)
generateIconsView.generate([...iconMapCommon, ...iconMap])


// WEBPACK FOOTER //
// ./src/m-common/components/SvgIcon/main.js